import React, { useState } from 'react';
import { BarChart3, PieChart, TrendingUp, DollarSign, CreditCard, TrendingDown, Calendar } from 'lucide-react';
import StatCard from './StatCard';
import AnalyticsTabs from './AnalyticsTabs';

// Mock data (you can move this to a separate file)
const mockStats = [
  {
    title: "Total Spending",
    value: "$1,010",
    change: "+10.5% from last month",
    icon: <DollarSign className="h-4 w-4 text-gray-500" />
  },
  {
    title: "Active Subscriptions",
    value: "22",
    change: "+4 from last month",
    icon: <CreditCard className="h-4 w-4 text-gray-500" />
  },
  {
    title: "Avg. Subscription Cost",
    value: "$45.91",
    change: "+2.5% from last month",
    icon: <TrendingUp className="h-4 w-4 text-gray-500" />
  },
  {
    title: "Potential Savings",
    value: "$150",
    change: "Based on usage patterns",
    icon: <TrendingDown className="h-4 w-4 text-gray-500" />
  }
];

export const AnalyticsDashboard = () => {
  return (
    <div className="container mx-auto py-6 px-4 space-y-8">
      <h1 className="text-2xl md:text-3xl font-bold">Subscription Analytics</h1>
      
      {/* Coming Soon Notice */}
      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <Calendar className="h-5 w-5 text-blue-400" />
          </div>
          <div className="ml-3">
            <p className="text-sm text-blue-700">
              This is a preview showing mock data. Enhanced analytics features are coming soon!
            </p>
          </div>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {mockStats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      {/* Tabs Section */}
      <AnalyticsTabs />
    </div>
  );
}; 